import {
    TabPanel,
    TabPanelHeaderTemplateOptions,
    TabView,
} from 'primereact/tabview';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StatusChip } from '../../workflows/StatusChip';
import './Console.scss';
import { InstanceStatuses, InstanceStatus } from '../logs/LogsDatas';
import { Logs } from '../logs/Logs';
import { useGraph } from '../../../hooks/useGraph';
import { useAppSelector } from '../../../hooks/hooks';

interface ILogsContainerProps {
    streamPods: Map<string, Map<string, InstanceStatuses>>;
    flowStatus: string;
}

export const Console = (props: ILogsContainerProps) => {

    const [selectedInstanceStatus, setSelectedInstanceStatus] = useState<InstanceStatus>();
    const [activeIndex, setActiveIndex] = useState(0);
    const {t} = useTranslation();
    const { activeNode, getNodeById } = useGraph();
    const { sidebar: sb} = useAppSelector((state) => state.editor);

    useEffect(() => {
        if (activeNode) {
            const indexActiveNodeInMap = Array.from(props.streamPods.keys()).findIndex(key => key === activeNode.getID());
            if (indexActiveNodeInMap > -1) {
                setActiveIndex(indexActiveNodeInMap + 1);
                const streamPod= props.streamPods.get(activeNode.getID());
                if (streamPod) {
                    selectDefaultLogLevel(streamPod);
                }
            }
        }
    }, [activeNode, sb]);

    const selectDefaultLogLevel = (streamPod: Map<string, InstanceStatuses>) => {
        const firstElement: any[] = streamPod.entries().next().value;
        if (firstElement && firstElement[1]) {
            const instanceStatuses: InstanceStatuses = firstElement[1];
            setSelectedInstanceStatus(instanceStatuses.statuses.find(instanceStatus => instanceStatus.status === instanceStatuses.current));
        }
    }

    const tabHeaderITemplate = (options: TabPanelHeaderTemplateOptions) => {
        return (
            <div onClick={options.onClick} className={`${options.className} dont-overflow`}>
                {options.titleElement}
            </div>
        );
    };
    const MenuTabBody = (data: { instances: Map<string, InstanceStatuses> }) => {
        const menuLateral: JSX.Element[] = [];

        if (!selectedInstanceStatus) {
          selectDefaultLogLevel(data.instances);
        }

        data.instances.forEach((value: InstanceStatuses, key: string) => {
          menuLateral.push(
            <div className="instance mb-2">
              <div className="label">
                {t("logs.instance")} : <strong>{key?.split("/")[0]}</strong>
              </div>
              <StatusChip status={value.current} className="mx-2" />
            </div>
          );

          menuLateral.push(
            <div className="instance mb-1">
              <p>{t("logs.historic")}</p>
            </div>
          );

          const buttons: JSX.Element[] = [];
          value.statuses.forEach(instanceStatus => {
            const isCurrentInstanceStatus =
              (selectedInstanceStatus?.data?.podname &&
                selectedInstanceStatus?.data?.podname === instanceStatus.data?.podname &&
                selectedInstanceStatus?.data?.status === instanceStatus.data?.status) ||
              (!instanceStatus.data?.podname &&
                selectedInstanceStatus?.data?.status === instanceStatus.data?.status);

            buttons.push(
              <div
                key={instanceStatus.status}
                className={`p-button ${isCurrentInstanceStatus ? "active" : ""}`}
                onClick={() => setSelectedInstanceStatus(instanceStatus)}
              >
                {t("kube-status." + instanceStatus.data.status.toLowerCase())}
              </div>
            );
          });

          if (buttons.length > 0) {
            menuLateral.push(<div className="buttons">{buttons}</div>);
          }
        });
      
        return <div className="menu-buttons dont-overflow scroll">{menuLateral}</div>;
      };
    const getNodeName = (nodeId: string): string => {
      const node = getNodeById(nodeId);
      if (node) {
        return node.getOptions().name ?? nodeId;
      } else {
        return nodeId;
      }
    }

    const renderTabsLogs = () => {
        let tabsLogs: JSX.Element[] = [];
        props.streamPods.forEach((value:  Map<string, InstanceStatuses>, key: string) => {
            tabsLogs.push(<TabPanel
                key={key}
                header={<div>{getNodeName(key)}</div>}
                className="dont-overflow"
                headerTemplate={tabHeaderITemplate}
            >
                <div className="bodyPanel dont-overflow">
                    <MenuTabBody instances={value}/>
                    {selectedInstanceStatus &&
                        <Logs key={selectedInstanceStatus.data.podname+selectedInstanceStatus.data.status}
                              instanceStatus={selectedInstanceStatus} />
                    }
                </div>
            </TabPanel>)
        });
        return tabsLogs;
    };

    const RenderStreamInstancesStatus = () => {
        let streamInstancesStatus: JSX.Element[] = [];
        props.streamPods.forEach((value:  Map<string, InstanceStatuses>, key: string) => {
            let instancesChips: JSX.Element[] = [];
            value.forEach((val:  InstanceStatuses, k: string) => {
                instancesChips.push(<div className="instance-status">
                    <span className="label">{t('logs.instance')} : <strong>{k?.split('/')[0]}</strong></span>
                    <div><StatusChip status={val.current}/></div>
                </div>);
            });


            streamInstancesStatus.push(<div className="pod-status ml-5" key={key}>
                <div className="status_label ">
                    ↪ <i>{getNodeName(key)}</i>
                </div>
                <div className="instances">{instancesChips}</div>
            </div>)
        });
        return <>{streamInstancesStatus}</>;
    }

    const renderTabStatus = () => {
        return (
            <TabPanel
                key="status"
                header={t('label.overview')}
                headerTemplate={tabHeaderITemplate}
                className="dont-overflow"
            >
                <div className="dont-overflow scroll pt-2">
                    {/* Flow's status */}
                    <div className="status-line">
                        <div className="status_label font-bold text-base">
                            {t('label.stream')}:
                        </div>
                        {props.flowStatus && <StatusChip status={props.flowStatus} className="mx-2"/>}
                    </div>
                    <RenderStreamInstancesStatus/>
                </div>
            </TabPanel>
        );
    };

    return (
        <div className="console-container">
            <TabView
                scrollable={true}
                activeIndex={activeIndex}
                onTabChange={(e) => {
                    setSelectedInstanceStatus(undefined);
                    setActiveIndex(e.index);
                }}
                className="dont-overflow"
            >
                {renderTabStatus()}
                {renderTabsLogs()}
            </TabView>
        </div>
    );
};
